import type { LucideIcon } from "lucide-react";

/** Estado vazio reutilizável — ícone + título + descrição. */
export function EmptyState({
  icon: Icon,
  title,
  description,
}: {
  icon: LucideIcon;
  title: string;
  description?: string;
}) {
  return (
    <div className="flex flex-col items-center justify-center gap-3 px-6 py-16 text-center">
      <div className="flex h-14 w-14 items-center justify-center rounded-full bg-surface text-faint">
        <Icon size={26} />
      </div>
      <h2 className="font-display text-lg text-ink">{title}</h2>
      {description ? <p className="max-w-xs text-sm text-muted">{description}</p> : null}
    </div>
  );
}
